import './ManageApiVersions.scss'; import 'primeflex/primeflex.scss';
import ApiVersion from 'models/ApiVersion';
import DisplayModel from 'components/chrome/DisplayModel';
import Card from 'components/chrome/Card';
import InfoDialog from 'components/chrome/InfoDialog';
import React from 'react';
import Tag from 'components/chrome/Tag';
import moment from 'moment';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { NavLink } from 'react-router-dom';


const MOCK_VERSION_DATA = [
  new ApiVersion({
    id: 3,
    version: '1.0.0',
    dateCreated: new Date(2020, 2, 12, 8, 15),
    environment: ['dev'],
    dataTypes: ['Pulse Rate', 'Pulse Oximetry', 'ECG'],
    security: 'One-way SSL with 256-bit AES-ECB sessions',
  }),
  new ApiVersion({
    id: 2,
    version: '0.2.0',
    dateCreated: new Date(2020, 2, 11, 9, 22),
    environment: ['beta', 'prod'],
    dataTypes: ['Pulse Rate', 'Pulse Oximetry'],
    security: 'One-way SSL with 256-bit AES-ECB sessions',
  }),
  new ApiVersion({
    id: 1,
    version: '0.1.0',
    dateCreated: new Date(2020, 2, 10, 9, 12),
    environment: [],
    dataTypes: ['Pulse Rate', 'Pulse Oximetry'],
    security: 'One-way SSL with 256-bit AES-ECB sessions',
  }),
];


const dataTableTemplates = {
  dateCreated: i => (
    moment(i.dateCreated).format('LLL')
  ),
  environment: i => (
    <div>
      {i.environment.map(e => (
        <NavLink key={e} to='/manage/environments'>
          <Tag
              className='environmentTag'
              label={e}
              icon='pi-cloud' />
        </NavLink>
      ))}
    </div>
  ),
  details: i => (
    <InfoDialog
        className='infoDialog'
        header='Version information'
        content={
          <DisplayModel data={i} load />
        } />
  ),
};


class ManageApiVersions extends React.Component {

  constructor() {
    super();
    this.state = { versions: MOCK_VERSION_DATA };
  }

  render() {
    return (
      <div className='ManageApiVersions'>
        <div className='section'>
          <div className='subtitle'>API Versions</div>
          <p>
            View the API specifications you have created.
          </p>
        </div>
        <div className='section'>
          <Card>
            <DataTable value={this.state.versions} resizableColumns={true}>
              <Column
                  className='columnDateCreated'
                  field='dateCreated'
                  header='Date Created'
                  body={dataTableTemplates.dateCreated} />
              <Column
                  className='columnVersion'
                  field='version'
                  header='Version'
                  body={i => i.version} />
              <Column
                  className='columnEnvironment'
                  field='environment'
                  header='Env'
                  body={dataTableTemplates.environment} />
              <Column
                  className='columnDetails'
                  field='details'
                  header='Details'
                  body={dataTableTemplates.details} />
            </DataTable>
          </Card>
        </div>
      </div>
    );
  }
}


export default ManageApiVersions;
